import React from 'react'
import { useTranslation } from 'react-i18next'

const MountainBikingPoints = () => {
  const { t } = useTranslation()

  return (
    <div>
      <h2 style={{ marginBottom: '20px' }}>{t('POINTS_TITLE')}</h2>
      <ul className="ul-square">
        <li>
          {t('MTB_POINTS_PHYSICALLY_DEMANDING')}
          {/* (en savoir +) */}
        </li>
        <li>
          {t('POINTS_RESPECT_ECOSYSTEM')}
          {/*  (en savoir +)*/}
        </li>
        <li>
          {t('POINTS_RESPECT_PEOPLE')}
          {/*  (en savoir +)*/}
        </li>
        <li>
          {t('MTB_POINTS_KNOW_RULES')}
          {/*  (en savoir +)*/}
        </li>
        <li>{t('MTB_POINTS_PEDESTRIAN_PRIORITY')}</li>
        <li>{t('MTB_POINTS_SAFETY_AVOID_SOLO')}</li>
        <li>{t('MTB_POINTS_SAFETY_WEAR_GEAR')}</li>
        <li>{t('MTB_POINTS_SAFETY_PHONE')}</li>
        <li>{t('MTB_POINTS_SAFETY_AVOID_ROADS')}</li>
        <li>
          {t('MTB_POINTS_SAFETY_AVOID_DEPARTMENTAL')}
          {/*  (en savoir +)*/}
        </li>
        <li>
          {t('MTB_POINTS_SAFETY_TRAIL_CONDITION')}
          {/*  (en savoir +)*/}
        </li>
        <li>{t('MTB_POINTS_SAFETY_FOREST')}</li>
      </ul>
    </div>
  )
}

export default MountainBikingPoints
